<template>
  <div 
    class="dest-card"
    :class="{ highlighted: isHighlighted }"
    @mouseenter="handleHover"
    @mouseleave="handleUnhover"
  >
    <div class="dest-header">
      <span class="dest-label">TO:</span>
      <span class="dest-ref">{{ tostop?.stop?.reference || toRef }}</span>
    </div>
    <div class="dest-name">{{ tostop?.stop?.fullname || 'Unknown Destination' }}</div>
    
    <div class="routes-sublist">
      <StopPanelRoutes 
        v-for="(routedets, routeidx) in tostop?.routes" 
        :key="routeidx"
        :stopData="stopData" 
        :tostop="tostop" 
        :route="routedets" 
        :fromRef="fromRef" 
        :toRef="toRef" 
      />
    </div>
  </div>
</template>

<script setup>
import { inject, defineProps, provide, computed } from 'vue';
import StopPanelRoutes from './StopPanelRoutes.vue';

const props = defineProps({
  stopData: {
    type: Object,
    required: true
  },
  tostop: {
    type: Object,
    required: true
  },
  fromRef: {
    type: String,
    required: true
  },
  toRef: {
    type: String,
    required: true
  }
});

const stateData = inject('stateData');
provide('stateData', stateData);

const isHighlighted = computed(() => {
  return stateData.hoveredRouteKey.value === `${props.fromRef}:${props.toRef}`;
});

function handleHover() {
  stateData.setExternalHighlight(props.fromRef, props.toRef);
}

function handleUnhover() {
  stateData.clearExternalHighlight(props.fromRef, props.toRef);
}

</script>

<style scoped>
.dest-card {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  padding: 8px 10px;
  border-left: 3px solid #367530;
  transition: all 0.2s ease;
}

.dest-card:hover, .dest-card.highlighted {
  background: rgba(255, 255, 255, 0.06);
  border-color: #ffc107;
  box-shadow: 0 0 10px rgba(255, 193, 7, 0.2);
}

.dest-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.7rem;
  margin-bottom: 2px;
}

.dest-label {
  color: #888;
  font-weight: 700;
}

.dest-ref {
  color: #367530;
  font-family: 'JetBrains Mono', monospace;
}

.dest-name {
  color: #ccc;
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 8px;
}

.routes-sublist {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>